import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';

export const INITIAL_STATE = {
    defaultFilters: constants.defaultFilters,
    filterDefinitions: constants.filterDefinitions,
    initialised: false,
    loading: false,
    summaryInfoStats: {
        excludePrincipal: '',
        excludeShortOption: '',
        imPledgeEur: 0,
        imReceiveEur: 0,
        imThresholdEur: 0,
        imReceiveUsd: 0,
        imPledgeUsd: 0,
        calcCurrencyPost: '',
        calcCurrencyCollect: '',
        monitoringThresholdLevel1Eur: 0,
        monitoringThresholdLevel2Eur: 0,
        monitoringThresholdLevel1Usd: 0,
        monitoringThresholdLevel2Usd: 0
    },
    summaryInfoLoaded: false,
    currencyToShow: 'EUR',
    currentServerFilters: [],
    summaryGridRows: [],
    summaryGridColumns: constants.summaryGridColumns,
    showCsaSummary: true,
    showDefaultMappings: false,
    currentStatus: {},
    currentType: '',
    transactionId: ''
};

const setInitialised = fp.set('initialised');
const setLoading = fp.set('loading');
const setSummaryInfoStats = fp.set('summaryInfoStats');
const setSummaryInfoLoaded = fp.set('summaryInfoLoaded');
const setCurrencyToShow = fp.set('currencyToShow');
const setSummaryGridRows = fp.set('summaryGridRows');
const setShowCsaSummary = fp.set('showCsaSummary');
const setShowDefaultMappings = fp.set('showDefaultMappings');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISED: {
            return setInitialised(action.initialised, state);
        }
        case actions.SET_LOADING: {
            return setLoading(action.loading, state);
        }
        case actions.SET_SHOW_DEFAULT_MAPPINGS: {
            return setShowDefaultMappings(action.shouldShow, state);
        }
        case actions.SHOW_CSA_SUMMARY: {
            return setShowCsaSummary(action.shouldShow, state);
        }
        case actions.SET_SUMMARY_GRID_ROWS: {
            return setSummaryGridRows(action.rows, state);
        }
        case actions.FETCH_SUMMARY_INFO_STATS_FAILED: {
            return setSummaryInfoStats({}, state);
        }
        case actions.SET_SUMMARY_INFO_STATS: {
            return fp.flow(
                setSummaryInfoStats(action.stats),
                fp.set('currentServerFilters', action.serverFilters)
            )(state);
        }
        case actions.SET_SUMMARY_INFO_LOADED: {
            return setSummaryInfoLoaded(action.loaded, state);
        }
        case actions.SET_CURRENCY_TO_SHOW: {
            return setCurrencyToShow(action.currency, state);
        }
        case actions.SET_DEFAULT_CONFIG: {
            return {
                ...state,
                currencyToShow: action.currency || INITIAL_STATE.currencyToShow,
                showCsaSummary: action.showCsaSummary,
                showDefaultMappings: action.showDefaultMappings
            };
        }
        case actions.SET_CURRENT_CSA_STATUS: {
            return {
                ...state,
                currentStatus: action.status
            };
        }
        case actions.SET_CURRENT_CSA_TYPE: {
            return {
                ...state,
                currentType: action.csaType
            };
        }
        case actions.SET_TRANSACTION_ID: {
            return {
                ...state,
                transactionId: action.id
            };
        }
        default:
            return state;
    }
}
